export const isMatchingMediaQuery = (mediaQueryString) => {
  if (typeof window === 'undefined') return;
  return window.matchMedia(mediaQueryString).matches;
};
